import type { FC } from 'react';
import { AlertCircleFilled } from '@eqi-investimentos/icons/web';
import { Box, Flex } from '@eqi-investimentos/react';
export const BadgeErrorForm: FC<BadgeErrorFormProps> = ({
  htmlError
}) => <Flex justifyContent="center" w="full" mt="2rem" data-sentry-element="Flex" data-sentry-component="BadgeErrorForm" data-sentry-source-file="index.tsx">
    <Flex data-testid="badge-error-form" alignItems="center" mb="2.5" px="5" py="0.625rem" gap="l" w="full" minW={{
    base: 'full',
    md: '420px'
  }} maxW={{
    base: 'full',
    md: '500px'
  }} minH="3.75rem" maxH="18.75rem" bgColor="background.brandLight" borderRadius="lg" transition="all 300ms ease-in-out" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <AlertCircleFilled color="content.brand" w={24} h={24} mt="-3px" data-sentry-element="AlertCircleFilled" data-sentry-source-file="index.tsx" />
      <Box sx={{
      p: {
        fontSize: {
          base: 'xs',
          md: 'sm'
        },
        fontWeight: 'bold',
        color: 'content.primary'
      }
    }} dangerouslySetInnerHTML={{
      __html: htmlError
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx" />
    </Flex>
  </Flex>;
type BadgeErrorFormProps = {
  htmlError: string;
};